/**
 * System > tools > snmp
 *
 * @since 2018-07-09
 * @author devp018
 */
import {fnGetCodeList} from '~/utils/admin-common'

export const state = () => ({
  errorMessage: '',
  apiUrlPath: {
    'snmp': '/api/sm/tools/snmp'
  },
  taskId: null,
  basicOptions: {
    // SNMP 옵션
    selSnmps: [], // fnGetCodeList('snmp_list'),
    // 인증방식 옵션
    user_auth_types: [
      {
        value: 'sha',
        label: 'SHA-1'
      },
      {
        value: 'md5',
        label: 'MD5'
      }
    ],
    // 메시지 암호화 옵션
    msg_auth_types: [
      {
        value: 'aes',
        label: 'AES'
      },
      {
        value: 'des',
        label: 'DES'
      }
    ]
  },
  rdSecureConfig: 1, // 보안 설정
  // target: '', // '192.168.40.61',
  target: {
    ip: '' // '192.168.40.61',
  },
  secureOption: {
    version: '1',
    community: '', // 'public',
    port: '161', // '161',
    oids: [],
    user_id: '',
    user_auth_type: '',
    user_auth_password: '',
    msg_auth_type: '',
    msg_auth_password: ''
  },
  basicOptionInit: {
    selSnmp: '1', // SNMP 선택
    user_auth_type: 'sha', // 사용자 인증
    msg_auth_type: 'aes', // 사용자인증, 메시지 암호화
    rdSecureConfig: '1' // 보안 설정
  },
  multipleSelect: [],
  tabs: [],
  oidOptions: [] // fnGetCodeList('OID_LIST')
})

export const mutations = {
  initSnmpOptions (state) {
    state.tabs = []
    state.target = {
      ip: ''
    }
    state.secureOption = {
      version: '1',
      community: '', // 'public',
      port: '161', // '161',
      oids: [],
      user_id: '',
      user_auth_type: '',
      user_auth_password: '',
      msg_auth_type: '',
      msg_auth_password: ''
    }
    state.basicOptions.selSnmps = fnGetCodeList('snmp_list')
    state.oidOptions = fnGetCodeList('OID_LIST')
  },
  initErrorMessage (state) {
    state.errorMessage = ''
  },
  setTaskId (state, id) {
    state.taskId = id
  },
  setContents (state, data) {
    let index = 1
    const tabs = []
    _.map(data.attributes.contents, (value, key) => {
      const _tabs = {}
      _tabs.title = `${_.toUpper(key)}`
      const tt = `${value}`
      _tabs.id = index++
      // _tabs.text = tt.replace(/\n,/g, '<br>')
      _tabs.text = tt.replace(/,/g, '')
      tabs.push(_tabs)
    })
    state.tabs = tabs
  },
  rdConfigChanged (state, payload) {
    state.basicOptionInit.rdSecureConfig = payload
    state.rdSecureConfig = payload

    // 보안 설정 초기화
    if (state.rdSecureConfig === 1) {
      state.secureOption.user_auth_type = '' // 인증 방식
      state.secureOption.user_auth_password = '' // 비밀번호
      state.secureOption.msg_auth_type = ''
      state.secureOption.msg_auth_password = ''
    } else if (state.rdSecureConfig === 2) {
      state.secureOption.msg_auth_type = '' // 메시지 암호화
      state.secureOption.msg_auth_password = '' // 비밀번호
    } else if (state.rdSecureConfig === 3) {
      // 초기화 하지 않음
    }
  },
  snmpChanged (state, payload) {
    state.basicOptionInit.selSnmp = payload
    state.rdSecureConfig = 1
    state.secureOption.version = payload

    // 사용자 이름, 보안 설정 초기화
    state.secureOption.user_id = ''
    state.secureOption.user_auth_type = ''
    state.secureOption.user_auth_password = ''
    state.secureOption.msg_auth_type = ''
    state.secureOption.msg_auth_password = ''
  },
  userAuthChanged (state, payload) {
    state.basicOptionInit.user_auth_type = payload
    state.secureOption.user_auth_type = payload
  },
  msgAuthChanged (state, payload) {
    state.basicOptionInit.msg_auth_type = payload
    state.secureOption.msg_auth_type = payload
  },
  oidChanged (state, payload) {
    state.secureOption.oids = payload
  },
  setErrorMessage (state, data) {
    const msg = _.isNil(data.msg) ? '' : {
      error: data.msg
    }
    state.errorMessage = msg
  }
}

export const actions = {
  // 실행버튼 클릭
  async runSnmpSettingData ({commit, state}) {
    state.tabs = []
    const {code, result} = await this.$axios.$post(`${state.apiUrlPath.snmp}`, {target: state.target.ip, options: state.secureOption}, {loading: false})
    if (code === 'async') {
      commit('setTaskId', result.id)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  async runSnmpPollingData ({commit, state}) {
    state.tabs = []
    const {code, result} = await this.$axios.$get(`${state.apiUrlPath.snmp}/${state.taskId}`, {loadingShow: false, loadingHide: false})
    if (code === 'async') {
      commit('setTaskId', result.id)
      return {code, result}
    }
    commit('setErrorMessage', result)
    return {code, result}
  },
  async rdConfigChange ({commit, state}, payload) {
    if (payload) {
      commit('rdConfigChanged', payload)
    }
  },
  async snmpChanged ({commit, state}, payload) {
    if (payload) {
      commit('snmpChanged', payload)
    }
  },
  async oidChanged ({commit, state}, payload) {
    if (payload) {
      const oids = payload.filter(item => {
        return typeof item === 'string' && item.toString().length > 0
      })
      const sendData = []
      sendData.push(oids)
      _.remove(oids, (item) => item === 'all')
      commit('oidChanged', oids)
    }
  },
  async userAuthChanged ({commit, state}, payload) {
    if (payload) {
      commit('userAuthChanged', payload)
    }
  },
  async msgAuthChanged ({commit, state}, payload) {
    if (payload) {
      commit('msgAuthChanged', payload)
    }
  }
}

export const getters = {
}

export const strict = false
